import { Breadcrumb } from '@tpct/admin-ui';
import type { BreadcrumbItem } from '@tpct/admin-ui';
import ThemeToggle from './ThemeToggle';
import { useTheme } from '../hooks/useTheme';

type BreadcrumbBarProps = {
  items: BreadcrumbItem[];
};

const BreadcrumbBar = ({ items }: BreadcrumbBarProps) => {
  const [theme, setTheme] = useTheme();

  return (
    <div className="hub-breadcrumb-bar">
      <Breadcrumb items={items} />
      <ThemeToggle value={theme} onChange={setTheme} />
    </div>
  );
};

export default BreadcrumbBar;
